import { render } from "./StarXpGate.vue?vue&type=template&id=9f87cbc4&ts=true"
import script from "./StarXpGate.vue?vue&type=script&lang=ts"
export * from "./StarXpGate.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__